import { emptySplitApi } from './base/emptySplitApi';
import {
  TCreateChatPayload,
  TGetChatHistoryParams,
  TGetChatHistoryResponse,
  TGetChatHistoryListResponse,
  TCreateChatRespose,
  TLoadmoreParams,
  TUpscaleImgResponse,
  TUpscaleImgRequestData,
  TUpscaleImgRequest,
  TOverrideImgResponse,
  TZoomOutRequest,
  TDeleteHistory,
} from '../utils/types/agrocraftArtisan';
import { createTokenHeader, createBasicHeaders } from '../utils/functions/headers';

export const otpService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['AgrocraftChat'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      createChat: builder.mutation<
        TCreateChatRespose,
        TCreateChatPayload
      >({
        query: (params) => ({
          url: 'generate_image',
          method: 'POST',
          data: params,
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
      getChatHistory: builder.query<
        TGetChatHistoryResponse[],
        TGetChatHistoryParams
      >({
        query: (params) => ({
          url: `chat/${params.sessionId}`,
          method: 'GET',
          params: {
            page: 1,
            limit: 100,
          },
        }),
        providesTags: ['AgrocraftChat'],
      }),
      getChatHistoryList: builder.query<
        TGetChatHistoryListResponse[],
        { fetchedForUserId: string | null }
      >({
        query: ({ fetchedForUserId }) => ({
          url: 'chat-session',
          method: 'GET',
          params: {
            fetchedForUserId,
            page: 1,
            limit: 100,
          },
        }),
        providesTags: ['AgrocraftChat'],
      }),
      loadMoreChat: builder.mutation<
        TCreateChatRespose,
        TLoadmoreParams
      >({
        query: ({ chatId, ratio, prompt_style }) => ({
          url: `generate_image/${chatId}`,
          method: 'POST',
          params: {
            ratio,
            prompt_style,
          },
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
      imageToPrompt: builder.mutation<
        { prompt: string },
        FormData
      >({
        query: (data) => ({
          url: 'imageToPrompt',
          method: 'POST',
          data,
          headers: createTokenHeader(),
          encrypt: false,
          decrypt: true,
        }),
      }),
      upscaleImage: builder.mutation<
        TUpscaleImgResponse,
        TUpscaleImgRequestData
      >({
        query: (data) => ({
          url: 'upscaleImage',
          method: 'POST',
          data,
        }),
      }),
      overrideImage: builder.mutation<
        TOverrideImgResponse,
        TUpscaleImgRequest
      >({
        query: ({ chatId, data }) => ({
          url: `upscaleImage/override/${chatId}`,
          method: 'POST',
          data,
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
      zoomOut: builder.mutation<void, TZoomOutRequest>({
        query: ({ sessionId, data }) => ({
          url: `outpaint/${sessionId}`,
          method: 'POST',
          data,
        }),
        invalidatesTags: ['AgrocraftChat'],
      }),
      getImageByLink: builder.query<Blob, string>({
        query: (imagePath) => ({
          url: `images/${imagePath}`,
          method: 'GET',
          headers: createBasicHeaders(),
          encrypt: false,
          decrypt: false,
          responseType: 'blob',
        }),
      }),
      trackImageDownload: builder.mutation<void, number | string>({
        query: (chatContentId) => ({
          url: `user_download/${chatContentId}`,
          method: 'POST',
        }),
      }),
       acceptMainPolicy : builder.mutation<void, void>({
        query: () => ({
          url: `auth/azure/accept-policy`,
          method: 'POST',
        }),
      }),
      deleteHistory: builder.mutation<void, TDeleteHistory>({
        query: ({ sessionId }) => ({
          url: `delete-session/${sessionId}`,
          method: 'POST',
        }),
         invalidatesTags: ['AgrocraftChat'],
      }),
    }),
  });

export const {
  useCreateChatMutation,
  useGetChatHistoryQuery,
  useGetChatHistoryListQuery,
  useLazyGetChatHistoryListQuery,
  useLoadMoreChatMutation,
  useImageToPromptMutation,
  useUpscaleImageMutation,
  useOverrideImageMutation,
  useZoomOutMutation,
  useGetImageByLinkQuery,
  useTrackImageDownloadMutation,
  useAcceptMainPolicyMutation,
  useDeleteHistoryMutation,
} = otpService;
